import { Box, Button } from "@mui/material";
import React from "react";
import { useCommonStyles } from "../../utils";

const CommonBox = ({
  RootBox,
  buttons,
  submitButtonName,
  CancelButtonName,
  onHandleSubmit,
  onHandleCancel,
  width,
  margin,
  btnPadding,
  marginTop
}) => {
  const { classes } = useCommonStyles();
  return (
    <>
      <Box
        className={classes.mainBox}
        width={width ? width : "100%"}
        margin={margin ? margin : "0"}
      >
        {RootBox}

        {buttons && (
          <Box
            display={"flex"}
            justifyContent={{
              xs: "center",
              sm: "flex-start",
              md: "flex-start",
            }}
            gap={2}
            padding={
              btnPadding
                ? btnPadding
                : "10px 40px 40px 40px"
            }
            marginTop={marginTop}
          >
            <Button className={classes.saveButton} onClick={onHandleSubmit}>
              {submitButtonName || "Save"}
            </Button>
            <Button className={classes.cancelButton} onClick={onHandleCancel}>
              {CancelButtonName || "Cancel"}
            </Button>
          </Box>
        )}
      </Box>
    </>
  );
};

export default CommonBox;
